import { Upload, Button, Spin, Image } from 'antd';
import { useContext, useEffect, useState } from 'react';
// import ThumbnailUpload from './ThumbnailUpload';
import { CDN, defaultApi } from 'services/api.helpers';
import { UploadOutlined } from '@ant-design/icons';
import { AuthContext } from 'context/AuthContext';
import axios from 'axios';
import {
  UploadRequestOption,
  UploadProgressEvent,
} from 'rc-upload/lib/interface';
import ImgCrop from 'antd-img-crop';
import { imageResizer } from '../../services/image-resize';

interface ThumbnailUploadProps {
  thumbnailUrl: string;
  setThumbnailUrl: React.Dispatch<React.SetStateAction<string>>;
}

const ThumbnailUpload = ({
  thumbnailUrl,
  setThumbnailUrl,
}: ThumbnailUploadProps) => {
  const context = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const ratio = 920 / 490; // 썸네일 비율

  const uploadImage = async (options: UploadRequestOption<any>) => {
    const { onError, onSuccess, file, onProgress } = options;
    setLoading(true);

    const config = {
      headers: { Authorization: context.token },
      onUploadProgress: (event: UploadProgressEvent) => {
        // const percent = Math.floor((event.loaded / event.total) * 100);
        // setProgress(percent);
        // if (percent === 100) {
        //   setTimeout(() => setProgress(0), 1000);
        // }
        onProgress({ percent: (event.loaded / event.total) * 100 });
      },
    };

    try {
      // 이미지 리사이징 적용 920*490 기준. 사용되는 파라미터는 imageResizer 함수 JSDock 주석 참조
      await imageResizer(file, 920).then(async (res) => {
        await axios
          .post(`${defaultApi}/images`, res, config)
          .then((response) => {
            setThumbnailUrl(response.data.url);
          });
        onSuccess('Ok');
      });
    } catch (err) {
      console.log('Error: ', err);
      setLoading(false);
      onError(err);
    }
  };

  useEffect(() => {
    setLoading(false);
  }, [thumbnailUrl]);

  return (
    <div className="flex flex-col gap-4 text-center">
      <div className="p-4 border border-[#d9d9d9] rounded-md">
        {loading ? (
          <Spin />
        ) : thumbnailUrl !== '' ? (
          <Image
            src={CDN + thumbnailUrl}
            alt="썸네일"
            className="w-full h-full block"
          />
        ) : (
          <Image
            src="error"
            fallback="data:image/png;base64,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"
          />
        )}
      </div>
      <ImgCrop modalClassName="blue-btn" aspect={ratio}>
        <Upload customRequest={uploadImage} showUploadList={false}>
          <Button icon={<UploadOutlined />}>업로드</Button>
        </Upload>
      </ImgCrop>
    </div>
  );
};
export default ThumbnailUpload;

// import { Upload, UploadFile, UploadProps } from 'antd';
// import { useContext, useState } from 'react';
// // import ThumbnailUpload from './ThumbnailUpload';
// import { AuthContext } from 'context/AuthContext';
// import ImgCrop from 'antd-img-crop';
// import { RcFile, UploadChangeParam } from 'antd/es/upload';
// import axios from 'axios';
// import { defaultApi } from 'services/api.helpers';
// import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
// import {
//   UploadRequestOption,
//   UploadProgressEvent,
// } from 'rc-upload/lib/interface';

// // interface ThumbnailUploadProps {
// //   thumbnail: string;
// //   setThumbnail: React.Dispatch<React.SetStateAction<string>>;
// // }

// interface ThumbnailUploadProps {
//   imageUrl: string;
//   setImageUrl: React.Dispatch<React.SetStateAction<string>>;
// }

// const ThumbnailUpload = ({ imageUrl, setImageUrl }: ThumbnailUploadProps) => {
//   const context = useContext(AuthContext);
//   const ratio = 920 / 490; // 썸네일 비율
//   const [loading, setLoading] = useState(false);

//   // const onChange: UploadProps['onChange'] = async (
//   //   info: UploadChangeParam<UploadFile>,
//   // ) => {
//   //   console.log(info);
//   //   if (info.file.status === 'uploading') {
//   //     setLoading(true);
//   //     // return;
//   //   }
//   //   if (info.file.status === 'done') {
//   //     setLoading(false);
//   //     console.log(info);
//   //     // setImageUrl(url);
//   //     // getBase64(info.file.originFileObj as RcFile, (url) => {
//   //     // });
//   //   }
//   //   // try {
//   //   //   await axios.post(`${defaultApi}/images`, newFileList[0].url, {
//   //   //     headers: {
//   //   //       Authorization: context.token,
//   //   //     },
//   //   //   });
//   //   // } catch (err) {
//   //   //   console.log('Error: ', err);
//   //   // }
//   // };

//   const uploadImage = async (options: UploadRequestOption<any>) => {
//     const { onError, onSuccess, file, onProgress } = options;
//     setLoading(true);

//     const fmData = new FormData();
//     const config = {
//       headers: { Authorization: context.token },
//       onUploadProgress: (event: UploadProgressEvent) => {
//         // const percent = Math.floor((event.loaded / event.total) * 100);
//         // setProgress(percent);
//         // if (percent === 100) {
//         //   setTimeout(() => setProgress(0), 1000);
//         // }
//         onProgress({ percent: (event.loaded / event.total) * 100 });
//       },
//     };
//     fmData.append('image', file);

//     try {
//       await axios
//         .post(`${defaultApi}/images`, fmData, config)
//         .then((response) => {
//           setImageUrl(defaultApi + response.data.url);
//         });
//       onSuccess('Ok');
//     } catch (err) {
//       console.log('Error: ', err);
//       setLoading(false);
//       onError(err);
//     }
//   };

//   const uploadButton = (
//     <div>
//       {loading ? <LoadingOutlined /> : <PlusOutlined />}
//       <div style={{ marginTop: 8 }}>Upload</div>
//     </div>
//   );

//   return (
//     <ImgCrop aspect={ratio}>
//       <Upload
//         listType="picture-card"
//         customRequest={uploadImage}
//         showUploadList={false}
//       >
//         {imageUrl ? (
//           <img src={imageUrl} alt="avatar" style={{ width: '100%' }} />
//         ) : (
//           uploadButton
//         )}
//       </Upload>
//     </ImgCrop>
//   );
// };
// export default ThumbnailUpload;
